import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'insider-brand_page_header_resume-click';
/**
 * Brand page header open Insider resume membership modal click
 */ export function trackInsiderBrandPageHeaderResumeClick() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false
    });
}
